import React from 'react'

import { useConsentConfig } from 'components/ConsentConfigProvider'

import LazyBanner from './LazyBanner'
import LazyModal from './LazyModal'


export default function ConsentPrompt() {
  const consentConfig = useConsentConfig()

  const Component = ( consentConfig.display_style === 'modal' ) ? LazyModal : LazyBanner

  return (
    <Component />
  )
}
